export const ROLE_FUNCTION_TO_USER_TYPE_MAP = {
    79: 1,
    78: 2,
};